import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function isInConversationView(): boolean {
    const globalListViewTypeReact = getUserConfiguration().UserOptions.GlobalListViewTypeReact;
    const listViewType =
        globalListViewTypeReact === undefined
            ? ReactListViewType.Conversation
            : globalListViewTypeReact;

    return listViewType === ReactListViewType.Conversation;
}
